// src/components/OfflineBanner.js
import React, { useState } from 'react';

function OfflineBanner({ onRetry }) {
  // einfache Inline-Styles, damit es garantiert als Overlay läuft
  const overlayStyle = {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0, 0, 0, 0.35)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
  };

  const cardStyle = {
    background: '#ffffff',
    borderRadius: '20px',
    padding: '24px 24px 20px',
    maxWidth: '420px',
    width: '90%',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.25)',
    textAlign: 'center',
    fontFamily:
      "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  };

  const titleStyle = {
    margin: '0 0 12px',
    fontSize: '1.1rem',
    fontWeight: 700,
    color: '#1f2933',
  };

  const textStyle = {
    margin: '0 0 18px',
    fontSize: '0.95rem',
    lineHeight: 1.5,
    color: '#4b5563',
  };

  const buttonStyle = {
    display: 'inline-block',
    padding: '10px 22px',
    borderRadius: '999px',
    border: 'none',
    fontSize: '0.95rem',
    fontWeight: 600,
    cursor: 'pointer',
    background: '#22c55e',
    color: '#ffffff',
    boxShadow: '0 4px 10px rgba(34, 197, 94, 0.4)',
    transition:
      'transform 0.1s ease, box-shadow 0.1s ease, background 0.15s ease',
  };

  const buttonHoverStyle = {
    background: '#16a34a',
  };

  // kleines Trickchen: Button bekommt beim MouseDown kurz einen "gedrückt"-Effekt
  const [isActive, setIsActive] = useState(false);

  return (
    <div style={overlayStyle}>
      <div style={cardStyle}>
        <h3 style={titleStyle}>🌧️ Ups! Heute regnet’s wohl nicht genug Daten…</h3>

        <p style={textStyle}>
          Wir konnten den Edens-Ernte-Server nicht erreichen.
          <br />
          Vielleicht ist die Gießkanne leer oder die Leitung verstopft.
          <br />
          Bitte versuch’s gleich nochmal 🌱
        </p>

        <button
  style={{
    ...buttonStyle,
    ...(isActive ? buttonHoverStyle : null),
  }}
  onMouseDown={() => setIsActive(true)}
  onMouseUp={() => setIsActive(false)}
  onMouseLeave={() => setIsActive(false)}

  onTouchStart={() => setIsActive(true)}
  onTouchEnd={() => setIsActive(false)}

  onClick={onRetry}
>
  Nochmal gießen
</button>
      </div>
    </div>
  );
}

export default OfflineBanner;